import { useEffect, useRef } from 'react';

export function useWatermarkProtection({
  wrapperSelector = '.watermark-protection',
  watermarkSelector = '.w-watermark',
  onTamper = () => {
    alert("Unauthorized action detected!");
    // window.location.reload();
    window.location.href = "/login";
  }
} = {}) {

  const expectedStylesRef = useRef({
    position: 'absolute',
    top: '0px',
    left: '0px',
    zIndex: '9',
    width: '100%',
    height: '100%',
    backgroundRepeat: 'repeat',
    pointerEvents: 'none'
  });

  useEffect(() => {
    let debounceTimeout = null;

    const enforceStyles = (el) => {
      const expected = expectedStylesRef.current;
      let tampered = false;

      Object.entries(expected).forEach(([key, value]) => {
        if (el.style[key] !== value) {
          el.style[key] = value; 
          tampered = true;
        }
      });

      return tampered;
    };

    const checkTamper = () => {
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = setTimeout(() => {
        const wrappers = document.querySelectorAll(wrapperSelector);

        wrappers.forEach(wrapper => {
          const watermark = wrapper.querySelector(watermarkSelector);

          // removed watermark
          if (!watermark) {
            onTamper();
            return;
          }

          const style = window.getComputedStyle(watermark);

          // hidden / removed visually
          if (
            style.display === 'none' ||
            style.visibility === 'hidden' ||
            style.opacity === '0' ||
            style.backgroundImage === 'none'
          ) {
            onTamper();
          }

          // style tampering (top/left/position etc)
          const healed = enforceStyles(watermark);

          if (healed) {
            onTamper();
          }
        });

      }, 100);
    };

    const observer = new MutationObserver(checkTamper);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    return () => {
      observer.disconnect();
      if (debounceTimeout) clearTimeout(debounceTimeout);
    };
  }, [wrapperSelector, watermarkSelector, onTamper]);
}


